class models {
    constructor(
        liqmodelId,
        name,
        frecuencia,
        diaInicio,
        mes,
        activa,
        cat,
        ws,
        topeMaxHExtras,
        tipoModeloId
    ) {
        this.liqmodelId = liqmodelId
        this.name = name
        this.id = liqmodelId
        this.frecuencia=frecuencia
        this.diaInicio=diaInicio
        this.mes=mes
        this.activa=activa === true ? '✔️' : ""
        this.cat=cat
        this.ws=ws
        this.topeMaxHExtras=topeMaxHExtras
        this.tipoModeloId=tipoModeloId
    }
    static fromJson({
        liqModeloId,
        nombre,
        frecuencia,
        diaInicio,
        mes,
        activa,
        cat,
        ws,
        topeMaxHExtras,
        tipoModeloId
    }) {
        return new models(
            liqModeloId,
            nombre,
            frecuencia,
            diaInicio,
            mes,
            activa,
            cat,
            ws,
            topeMaxHExtras,
            tipoModeloId

        )
    }
}
export default models